import { SearchQuery } from '@rtls/core/models/rpc/search-query';

export function modifyQueryAttributes(
	query: SearchQuery,
	matcher: (attribute: string) => boolean,
	modifier: (key: string) => string,
): SearchQuery {
	const cloneQuery = Object.assign({}, query);
	modifyQueryRecursively(cloneQuery, matcher, modifier);
	return cloneQuery;
}

function modifyQueryRecursively(
	query: SearchQuery,
	matcher: (attribute: string) => boolean,
	modifier: (key: string) => string,
): void {
	if (query.predicates != null) {
		query.predicates.forEach((q) => modifyQueryRecursively(q, matcher, modifier));
	}
	if (query.attribute) {
		if (matcher(query.attribute)) {
			query.attribute = modifier(query.attribute);
		}
	}
}
